import styled from 'styled-components';

export const ContainerPage404 = styled.div``;
